module.exports = __webpack_public_path__ + "static/media/MoveUp.57eb59e0.svg";